var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 12V18C20 20.2091 18.2091 22 16 22H8C5.79086 22 4 20.2091 4 18V12",
    stroke: "#28303F",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7689 2H7.23146C5.41411 2 3.77985 3.24476 3.1049 5.14305L2.34692 7.27487C2.11747 7.92019 1.95887 8.61074 2.12622 9.27488C2.52257 10.8478 3.80844 12 5.33354 12C7.17449 12 8.66687 10.3211 8.66687 8.25C8.66687 10.3211 10.1593 12 12.0002 12C13.8412 12 15.3335 10.3211 15.3335 8.25C15.3335 10.3211 16.8259 12 18.6669 12C20.192 12 21.4778 10.8478 21.8742 9.27488C22.0415 8.61074 21.8829 7.92019 21.6535 7.27487L20.8955 5.14305C20.2206 3.24475 18.5863 2 16.7689 2Z",
    stroke: "#28303F",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 17C11.3561 18.3404 12.6476 18.3263 15 17",
    stroke: "#28303F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.82ca088e36e34c0b1b21560b7316e8d6.svg";
export { ForwardRef as ReactComponent };